import { Controller } from "@hotwired/stimulus"
import "@selectize/selectize"

export default class extends Controller {
  static targets = ["selectList", "newListName", "dropdownTrigger", "saveButton"]
  static values = {
    hasLists: Boolean,
  }

  connect() {
    this.initializeController()
  }

  disconnect() {
    // Destroy the Selectize instance to prevent memory leaks
    if (this.listsListSelectize && this.listsListSelectize[0]) {
      this.listsListSelectize[0].selectize.destroy()
    }

    // Remove the click event listener to prevent memory leaks
    if (this.handleClickOutside) {
      document.removeEventListener("click", this.handleClickOutside)
    }
  }

  initializeController() {
    if (this.hasListsValue) {
      this.listsListSelectize = $(this.selectListTarget).selectize()
    }

    this.initializeDropdown()

    this.handleClickOutside = this.handleClickOutside.bind(this)
    document.addEventListener("click", this.handleClickOutside)
  }

  initializeDropdown() {
    const dropdownTriggers = this.element.querySelectorAll('[data-bs-toggle="dropdown"]')
    dropdownTriggers.forEach((trigger) => {
      trigger.removeAttribute("data-bs-toggle")
      trigger.addEventListener("click", (e) => {
        e.preventDefault()
        this.toggleDropdown()
      })
    })
  }

  toggleDropdown() {
    const dropdownMenu = this.element.querySelector(".dropdown-menu")
    if (dropdownMenu) {
      dropdownMenu.classList.toggle("show")
    }
  }

  handleClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.dismiss()
    }
  }

  dismiss() {
    // Close the dropdown by removing the show class
    const dropdownMenu = this.element.querySelector(".dropdown-menu")
    if (dropdownMenu) {
      dropdownMenu.classList.remove("show")
    }
  }

  listTypeSelection(event) {
    if (event.params.type === "new") {
      this.newListNameTarget.disabled = false
      this.newListNameTarget.required = true
      this.listsListSelectize[0].selectize.disable()
    } else if (event.params.type === "existing") {
      this.newListNameTarget.disabled = true
      this.newListNameTarget.required = false
      this.listsListSelectize[0].selectize.enable()
    }
  }

  // Get lists and update the <select> -
  // triggered when a list is created (listCreated event)
  updateListsList(event) {
    const newList = event.detail.list
    const selectize = this.listsListSelectize[0].selectize

    selectize.addOption({ value: newList.id, text: newList.name })
    selectize.refreshOptions(false)
    selectize.setValue(newList.id)
  }
}
